import mainCss from '../styles/original-main.css?raw';
import componentsCss from '../styles/original-components.css?raw';
import animationsCss from '../styles/original-animations.css?raw';
import criticalCss from '../styles/critical-inline.css?raw';

const STYLE_ID = 'beatline-vite-bundled-styles-c40';

export function installBundledBeatLineStyles(): void {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.setAttribute('data-owner', 'vite-typescript');
  style.textContent = [
    '/* BeatLine C40: CSS is bundled by Vite/TypeScript, not served from the backend plugin. */',
    mainCss,
    componentsCss,
    animationsCss,
    criticalCss,
  ].join('\n\n');
  document.head.appendChild(style);
}
